/** Under `/reports` because it is one: same `reports:read`, same section of the nav. */
export const FLEET_REPORT_PATH = '/reports/fleet'
